import {Buffer} from "buffer";

export const decodeJSON = encoded => JSON.parse(Buffer.from(encoded, "base64").toString());
export const encodeJSON = decoded => Buffer.from(JSON.stringify(decoded)).toString("base64");